import { ApolloProvider } from '@apollo/client';
import { theme } from '@c4ads/c4blocks';
import createCache from '@emotion/cache';
import { CacheProvider } from '@emotion/react';
import { ThemeProvider } from '@mui/material/styles';
import { LicenseInfo } from '@mui/x-license-pro';
import { cloneDeep } from 'lodash';
import posthog from 'posthog-js';
import { PostHogProvider } from 'posthog-js/react';
import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from "@sentry/react";

import App from './App';
import apolloClient from './api/apollo';
import { AuthProvider } from './api/auth';
import { deeplyReplaceValues } from './helpers';
import './index.css';

LicenseInfo.setLicenseKey(process.env.REACT_APP_MUI_LICENSE || '');

Sentry.init({
  dsn: "https://000918fd1ff98241af5af9121959f537@o295592.ingest.us.sentry.io/4510393442369536",
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  
  sendDefaultPii: process.env.REACT_APP_SENTRY_SEND_DEFAULT_PII === 'true',
});

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

const cache = createCache({
    key: 'css',
    prepend: true,
});

const preparedTheme = deeplyReplaceValues(cloneDeep(theme), 'fontFamily', 'Inter');
posthog.init(process.env.REACT_APP_PUBLIC_POSTHOG_KEY as string, {
    api_host: process.env.REACT_APP_PUBLIC_POSTHOG_HOST,
    person_profiles: 'identified_only',
    autocapture: {
        dom_event_allowlist: [],
    },
});

root.render(
    <CacheProvider value={cache}>
        <ApolloProvider client={apolloClient}>
            <AuthProvider>
                <ThemeProvider theme={preparedTheme}>
                    <PostHogProvider client={posthog}>
                        <App />
                    </PostHogProvider>
                </ThemeProvider>
            </AuthProvider>
        </ApolloProvider>
    </CacheProvider>
);
